"use client";

import { useEffect } from "react";
import { reportClientError } from "@/lib/errors/client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError(error, { tags: { source: "route-error", route: "/drops" } });
  }, [error]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <p className="text-foreground text-lg font-bold tracking-widest uppercase">
          Something went wrong
        </p>
        <p className="text-muted-foreground max-w-md text-sm">
          {error.message || "An unexpected error occurred."}
        </p>
        <button
          onClick={reset}
          className="border-foreground bg-foreground text-background hover:bg-background hover:text-foreground rounded-none border-2 px-8 py-3 text-xs font-bold tracking-widest uppercase transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
